import * as React from "react";
import { TextBox } from "../../forms/informedv4/TextBoxV4";
import { MultiSelect } from "../../forms/informedv4/MultiSelectV4";
import { nameof } from "ts-simple-nameof";
import { RequiredNotBlank, Required } from "../../forms/validation/Required";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Option } from "../../misc/OptionFormatters";

export interface NewDirectoryDialogFormState {
    Id: string;
    ServerDirectory: string;
    FriendlyName: string;
    UserRoles: Option[];
}

export const RenderCheckingIcon = (checkingDirectory: boolean) => {
    if (checkingDirectory) {
        return (
            <span>
                &nbsp;<FontAwesomeIcon icon={faCircleNotch} className="fa-spin" /> Checking Directory...
            </span>
        );
    } else {
        return null;
    }
}

export const DirectoryDialogForm = ({ roles }) => {
    return (
        <>
            <div className="row">
                <div className="form-group">
                    <div className="col-sm-4">
                        <label htmlFor="ServerDirectory" className="pull-right">Server Location</label>
                    </div>
                    <div className="col-sm-8">
                        <div>Enter a location on the server to reference</div>
                        <TextBox name="ServerDirectory" id="ServerDirectory" field={nameof<NewDirectoryDialogFormState>(f => f.ServerDirectory)} validate={RequiredNotBlank} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group">
                    <div className="col-sm-4">
                        <label htmlFor="FriendlyName" className="pull-right">Friendly Name</label>
                    </div>
                    <div className="col-sm-8">
                        <div>Enter a friendly name for the directory so the true path is not visible to users</div>
                        <TextBox name="FriendlyName" id="FriendlyName" field={nameof<NewDirectoryDialogFormState>(f => f.FriendlyName)} validate={RequiredNotBlank} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group">
                    <div className="col-sm-4">
                        <label htmlFor="UserRoles" className="pull-right">User Roles To Link</label>
                    </div>
                    <div className="col-sm-8">
                        <div>Select the user roles who should have access to the files within this directory</div>
                        <MultiSelect
                            name="UserRoles"
                            id="UserRoles"
                            field="UserRoles"
                            options={roles}
                            validate={Required}
                            labelKey="label"
                            valueKey="value"
                            multi
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
